"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hyperspace = void 0;
exports.hyperspace = {
    Space: {
        id: 'H256',
        dna: 'H256',
        price: 'Balance',
        gen: 'u64',
    },
    SpaceId: 'Hash',
    HypaspaceId: 'Hash',
    HypaspaceMetadata: {
        name: 'Vec<u8>',
    },
    Item: {
        CommodityId: 'CommodityId',
        CommodityInfo: 'CommodityInfo',
    },
    ItemId: 'Hash',
    ItemInfo: {
        dob: 'u64',
        dna: 'Hash',
    },
};
